module.exports = "<head>\n    <link rel=\"stylesheet\" href=\"./dist/messenger.css\">\n</head>"